import { PublicOrderProductsResponse } from '../models/ss-api/responses/public.order.products.response';
import { TrainingJoinEventRequest } from '../models/ss-api/requests/training.join.event.request';
import { CancelProductRequest } from '../models/ss-api/requests/cancel.product.request';
import { UpgradeProductResponse } from '../models/ss-api/responses/upgrade.product.response';
import { AddCreditCardRequest } from '../models/ss-api/requests/add.credit.card.request';
import { CreditCardResponseArray } from '../models/ss-api/responses/credit.card.response';
import { ChangePasswordRequest } from '../models/ss-api/requests/change.password.request';
import { GISUsageHistoryItemResponseArray } from '../models/ss-api/responses/gis.history.item.response';
import { GISPurchaseItemResponseArray } from '../models/ss-api/responses/gis.purchase.item.response';
import { BillingHistoryResponseArray } from '../models/ss-api/responses/billing.history.response';
import { TwoFactorAuthenticationRequest } from '../models/ss-api/requests/twoFactorAuthentication.request';
import { SendTwoFactorCodeOptionRequest } from '../models/ss-api/requests/sendTwoFactorCodeOption.request';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CommHttpService } from './comm-http.service';
import { IBaseResponse } from 'app/models/comm-http/responses/BaseResponse';
import { HttpError } from 'app/models/errors/HttpError';
import { ssApiResponse } from '../models/ss-api/responses/ss-api.response';
import { LoginResponse } from 'app/models/ss-api/responses/login.response';
import { LoginRequest } from 'app/models/ss-api/requests/login.request';
import { DashboardProductsResponse } from 'app/models/ss-api/responses/dashboard.products.response';
import { CreditCardResponse } from 'app/models/ss-api/responses/credit.card.response';
import { MemberBasicInfoResponse } from 'app/models/ss-api/responses/member.basic.info.response';
import { GISBundleResponseArray } from 'app/models/ss-api/responses/gis.bundle.response';
import { CalendarEventResponseArray } from 'app/models/ss-api/responses/calendar.event.response';
import { OrderGISRequest } from 'app/models/ss-api/requests/order.gis.request';
import { TrainingEventDetailsResponse } from 'app/models/ss-api/responses/training.event.details.response';
import { NewMemberRequest } from 'app/models/ss-api/requests/new.member.request';
import { PublicOrderProductsResponseArray } from 'app/models/ss-api/responses/public.order.products.response';
import { AddProductRequest } from 'app/models/ss-api/requests/add.product.request';
import { UpgradableProductsResponseArray } from 'app/models/ss-api/responses/upgradable.products.response';
import { UpgradeProductRequest } from 'app/models/ss-api/requests/upgrade.product.request';
import { RedirectResponse } from 'app/models/ss-api/responses/redirect.response';
import { UpdateCartRequest } from 'app/models/ss-api/requests/update.cart.request';
import { ResetPasswordRequest } from 'app/models/ss-api/requests/reset.password.request';
import { SetNewPasswordRequest } from 'app/models/ss-api/requests/set.new.password.request';
import { TrainingJoinEventResponse } from 'app/models/ss-api/responses/training.join.event.response';
import { MemberDesignerLicenseBasicsResponseArray } from 'app/models/ss-api/responses/member.designers.licenses.basics.response';
import { IUnlockLoginRequest } from 'app/models/ss-api/requests/unlock.code.request';
import { UnfunishedOrderData } from 'app/models/ss-api/responses/unfinished.order.data';
import { FinishOrderRequest } from 'app/models/ss-api/requests/finish.order.request';
import { DesignerInstructionsRequest } from '../models/ss-api/requests/designer.instructions.request';
import { YardAddonOrderRequest } from '../models/ss-api/requests/yard.addon.order.request';
import { YardAddonPriceResponse } from 'app/models/ss-api/responses/yard.addon.price.response';
import { UpgradeSimulationResponse } from '../models/ss-api/responses/upgrade.simulation.response';
import { ReactivateSimulationResponse } from '../models/ss-api/responses/reactivate.simulation.response';
import { ReactivateRequest } from '../models/ss-api/requests/reactivate.request';
import { CancelYardRequest } from '../models/ss-api/requests/cancel.yard.request';
import { NewMemberResponse } from '../models/ss-api/responses/new.member.response';
import { PayInvoiceRequest } from '../models/ss-api/requests/pay.invoice.request';
import { environment } from 'environments/environment';
import { CdKeyReassignRequest } from '../models/ss-api/requests/cdkey.reassign.request';
import { TrainingEvent } from '../models/domain/training.event';
import { RegisterForTrainingEventRequest } from '../models/ss-api/requests/register.for.training.event.request';
import { MemberTrainingCalendarResponse } from '../models/ss-api/responses/member.training.calendar.response';
import { TrainingCalendarRequest } from '../models/ss-api/requests/training.calendar.request';
import { MemberTrainingCertificateResponseArray } from '../models/ss-api/responses/member.training.certificate.response';
import { MemberTrainingCertificatesRequest } from '../models/ss-api/requests/member.training.certificates.request';
import { TrainingHistoryResponseArray } from '../models/ss-api/responses/training.history.response';
import { RegisterForTrainingEventResponse } from '../models/ss-api/responses/register.for.training.event.response';
import { UpdateTrainingEventSubscriptionStatusResponse } from '../models/ss-api/responses/update.training.subscription.status.response';
import { UpdateTrainingEventSubscriptionStatusRequest } from '../models/ss-api/requests/update.training.event.subscription.status.request';
import { ReactivateSimulationRequest } from '../models/ss-api/requests/reactivate.simulation.request';
import { UpdateCreditCardExpirationRequest } from '../models/ss-api/requests/update.credit.card.expiration.request';
import { ReactivateSimulationRequestv2 } from '../models/ss-api/requests/reactivate.simulation.request.v2';
import { ReactivateSimulationResponsev2 } from '../models/ss-api/responses/reactivate.simulation.response.V2';
import { ReactivateRequestv2 } from '../models/ss-api/requests/reactivate.request.v2';
import { CheckForExistingMemberResponse } from '../models/ss-api/responses/check.for.existing.member.response';
import { CheckForExistingMemberRequest } from '../models/ss-api/requests/check.for.existing.member.request';
import { GetTrainingClassesRequest } from 'app/models/ss-api/requests/get.training.classes.request';
import { TrainingClassArray } from 'app/models/domain/training.class';
import { CheckHoldEligibilityResponse } from 'app/models/ss-api/responses/check.hold.eligibility.response';
import { HoldRequest } from 'app/models/ss-api/requests/hold.request';
import { ResumeLicenseRequest } from 'app/models/ss-api/requests/resume.license.request';
import { ResumeLicenseSimulationResponse } from 'app/models/ss-api/responses/resume.license..simulation.response';
import { ResumeLicenseSimulationRequest } from 'app/models/ss-api/requests/resume.license.simulation.request';
import { UpdateMemberProfileRequest } from 'app/models/ss-api/requests/update.member.profile.request';
import { MemberProfile } from 'app/models/domain/member.profile';
import { MemberAnnouncementArray } from 'app/models/ss-api/responses/member.announcement';
import { UpdateCartResponse } from 'app/models/ss-api/responses/update.cart.response';



class ssApiUrls {

    // authentication
    static readonly Authentication_Login: string = 'Authentication/Login';
    static readonly Authentication_Logout: string = 'Authentication/Logout';
    static readonly Authentication_SendTwoFactorCode: string = 'Authentication/SendTwoFactorCode';
    static readonly Authentication_TwoFactorAuthentication: string = 'Authentication/TwoFactorAuthentication';
    static readonly Authentication_ChangePassword: string = 'Authentication/ChangePassword';
    static readonly Authentication_ResetPassword: string = 'Authentication/ResetPassword';
    static readonly Authentication_SetNewPassword: string = 'Authentication/SetNewPassword';
    static readonly Authentication_UnlockLogin: string = 'Authentication/UnlockLogin';
    static readonly Authentication_SessionInfo: string = 'Authentication/SessionInfo';

    // member
    static readonly Member_New: string = 'Member/New';
    static readonly Member_BasicInfo: string = 'Member/BasicInfo';
    static readonly Member_Credit: string = 'Member/Credit';
    static readonly Member_MemberDesignersLicensesBasics: string = 'Member/MemberDesignersLicensesBasics';
    static readonly Member_FinishOrder: string = 'Member/FinishOrder';
    static readonly Member_CheckForExistingMember: string = 'Member/CheckForExistingMember';
    static readonly Member_Profile: string = 'Member/MemberProfile';
    static readonly Member_UpdateProfile: string = 'Member/UpdateMemberProfile';    
    static readonly Member_MemberAnnouncements: string = 'Member/MemberAnnouncements';

    // referral
    static readonly Referral_Redirect: string = 'Referral/GetRedirect';

    // sales
    static readonly Sales_UpdateCart: string = 'Sales/UpdateCart';
    static readonly Sales_GetUnfinishedOrderData: string = 'Sales/GetUnfinishedOrderData';

    // products
    static readonly Products_PublicOrderProducts: string = 'Products/PublicOrderProducts';
    static readonly Products_OrderProducts: string = 'Products/OrderProducts';
    static readonly Products_PublicAndSpecialOrderProducts: string = 'Products/PublicAndSpecialOrderProducts';
    static readonly Products_Add: string = 'Products/Add';
    static readonly Products_Cancel: string = 'Products/Cancel';
    static readonly Products_MyProducts: string = 'Products/MyProducts';
    static readonly Products_UpgradableProducts: string = 'Products/UpgradableProducts';
    static readonly Products_Upgrade: string = 'Products/Upgrade';
    static readonly Products_UpgradeSimulation: string = 'Products/UpgradeSimulation';
    static readonly Products_ReactivateSimulation: string = 'Products/ReactivateSimulation/';
    static readonly Products_Reactivate: string = 'Products/Reactivate';
    static readonly Products_ReactivateSimulationv2: string = 'Products/ReactivateSimulationv2/';
    static readonly Products_Reactivatev2: string = 'Products/Reactivatev2';
    static readonly Products_CheckHoldEligibility: string = 'Products/CheckHoldEligibility/';
    static readonly Products_Hold: string = 'Products/Hold/';
    static readonly Products_ExtendHold: string = 'Products/ExtendHold/';
    static readonly Products_ResumeLicense: string = 'Products/ResumeLicense/';
    static readonly Products_ResumeLicenseSimulation: string = 'Products/ResumeLicenseSimulation/';

    // license
    static readonly License_Reassign: string = 'License/Reassign';
    static readonly License_AssigToLoggedinUser: string = 'License/AssigToLoggedinUser';
    static readonly License_GetFirstLicenseKey: string = 'License/GetFirstLicenseKey';
    static readonly License_SendLicenseKeyInstructionsToDesignerEmail: string = 'License/SendLicenseKeyInstructionsToDesignerEmail';

    // billing
    static readonly Billing_History: string = 'Billing/History';
    static readonly Billing_PayInvoice: string = 'Billing/PayInvoice';

    // GIS
    static readonly GIS_PurchaseHistory: string = 'GIS/PurchaseHistory';
    static readonly GIS_UsageHistory: string = 'GIS/UsageHistory';
    static readonly GIS_SharedBundle: string = 'GIS/SharedBundle';
    static readonly GIS_IndividualBundle: string = 'GIS/IndividualBundle';
    static readonly GIS_Order: string = 'GIS/Order';

    // Yard
    static readonly Yard_GetPricing: string = 'Yard/GetPricingForLicense/';
    static readonly Yard_Add: string = 'Yard/Add/';
    static readonly Yard_Cancel: string = 'Yard/Cancel/';

    // credit card
    static readonly CreditCard_GetDefault: string = 'CreditCard/GetDefault';
    static readonly CreditCard_GetAll: string = 'CreditCard/GetAll';
    static readonly CreditCard_Add: string = 'CreditCard/Add';
    static readonly CreditCard_UpdateExpiration: string = 'CreditCard/UpdateExpiration';
    static readonly CreditCard_SetAsDefault: string = 'CreditCard/SetDefault';
    static readonly CreditCard_Delete: string = 'CreditCard/Delete';

    // training
    static readonly Training_GetTrainingEventByID: string = 'Training/GetTrainingEventByID/';
    static readonly Training_RegisterForTrainingEvent: string = 'Training/RegisterForTrainingEvent/';
    static readonly Training_GetMemberTrainingCalendar: string = 'Training/GetMemberTrainingCalendarv2/';
    static readonly Training_GetMemberTrainingCertificates: string = 'Training/GetMemberTrainingCertificates/';
    static readonly Training_GetTrainingHistory: string = 'Training/GetTrainingHistory/';
    static readonly Training_UpdateTrainingEventSubscriptionStatus: string = 'Training/UpdateTrainingEventSubscriptionStatus/';
    static readonly Training_GetTrainingClasses: string = 'Training/GetTrainingClasses/';
}

@Injectable()
export class ssApiService extends CommHttpService {

    // private baseUrl: string = "https://members-pci-api.structurestudios.com/api/";
    // private baseUrl: string = "http://localhost:55189/api/"
    private baseUrl: string = environment.baseUrl;
    private envName: string = environment.envName;
    public isDev: boolean = false;

    // busy
    public IsBusy: boolean = false;

    // events
    public onIsBusyChanged = new Subject<boolean>();
    public onResponse = new Subject<ssApiResponse>();

    public onLoginResponse = new Subject<IBaseResponse<LoginResponse>>();
    public onSessionInfoResponse = new Subject<IBaseResponse<LoginResponse>>();
    public onLogoutResponse = new Subject<IBaseResponse<string>>();
    public onSendTwoFactorCode = new Subject<IBaseResponse<string>>();
    public onTwoFactorAuthentication = new Subject<IBaseResponse<string>>();
    public onChangePassword = new Subject<IBaseResponse<string>>();
    public onResetPasswordRequest = new Subject<IBaseResponse<string>>();
    public onSetNewPassword = new Subject<IBaseResponse<string>>();
    public onUnlockLogin = new Subject<IBaseResponse<string>>();

    public onMemberNew = new Subject<IBaseResponse<NewMemberResponse>>();
    public onFinishOrder = new Subject<IBaseResponse<string>>();
    public onMemberBasicInfo = new Subject<IBaseResponse<MemberBasicInfoResponse>>();
    public onMemberDesignersLicensesBasics = new Subject<IBaseResponse<MemberDesignerLicenseBasicsResponseArray>>();
    public onMemberCheckForExistingMember = new Subject<IBaseResponse<CheckForExistingMemberResponse>>();
    public onMemberProfile = new Subject<IBaseResponse<MemberProfile>>();
    public onMemberUpdateProfile = new Subject<IBaseResponse<string>>();
    public onMemberMemberAnnouncements = new Subject<IBaseResponse<MemberAnnouncementArray>>();

    public onReferralRedirect = new Subject<IBaseResponse<RedirectResponse>>();

    public onProductsPublicOrderProducts = new Subject<IBaseResponse<PublicOrderProductsResponseArray>>();
    public onProductsOrderProducts = new Subject<IBaseResponse<PublicOrderProductsResponseArray>>();
    public onProductsPublicAndSpecialOrderProducts = new Subject<IBaseResponse<PublicOrderProductsResponseArray>>();
    public onProductsMyProducts = new Subject<IBaseResponse<DashboardProductsResponse>>();
    public onProductsUpgradableProducts = new Subject<IBaseResponse<UpgradableProductsResponseArray>>();
    public onProductsAdd = new Subject<IBaseResponse<string>>();
    public onProductsCancel = new Subject<IBaseResponse<string>>();
    public onProductUpgrade = new Subject<IBaseResponse<UpgradeProductResponse>>();
    public onProductUpgradeSimulation = new Subject<IBaseResponse<UpgradeSimulationResponse>>();
    public onProductReactivateSimulationn = new Subject<IBaseResponse<ReactivateSimulationResponse>>();
    public onCheckHoldEligibility = new Subject<IBaseResponse<CheckHoldEligibilityResponse>>();
    public onHoldLicense = new Subject<IBaseResponse<boolean>>();
    public onExtendHoldLicense = new Subject<IBaseResponse<boolean>>();
    public onResumeLicense = new Subject<IBaseResponse<boolean>>();
    public onResumeLicenseSimulation = new Subject<IBaseResponse<ResumeLicenseSimulationResponse>>();

    public onProductReactivate = new Subject<IBaseResponse<String>>();
    public onProductReactivateSimulationnv2 = new Subject<IBaseResponse<ReactivateSimulationResponse>>();
    public onProductReactivatev2 = new Subject<IBaseResponse<String>>();


    public onLicenseReassign = new Subject<IBaseResponse<string>>();
    public onAssigToLoggedinUser = new Subject<IBaseResponse<string>>();
    public onGetFirstLicenseKey = new Subject<IBaseResponse<string>>();
    public onSendLicenseKeyInstructionsToDesignerEmail = new Subject<IBaseResponse<string>>();

    public onBillingHistory = new Subject<IBaseResponse<BillingHistoryResponseArray>>();
    public onBillingPayInvoice = new Subject<IBaseResponse<string>>();

    public onSalesUpdateCart = new Subject<IBaseResponse<UpdateCartResponse>>();
    public onSalesGetUnfinishedOrderData = new Subject<IBaseResponse<UnfunishedOrderData>>();

    public onGISPurchaseHistory = new Subject<IBaseResponse<GISPurchaseItemResponseArray>>();
    public onGISUsageHistory = new Subject<IBaseResponse<GISUsageHistoryItemResponseArray>>();
    public onGISSharedBundle = new Subject<IBaseResponse<GISBundleResponseArray>>();
    public onGISIndividualBundle = new Subject<IBaseResponse<GISBundleResponseArray>>();
    public onGISOrder = new Subject<IBaseResponse<string>>();

    public onCreditCardGetDefault = new Subject<IBaseResponse<CreditCardResponse>>();
    public onCreditCardGetAll = new Subject<IBaseResponse<CreditCardResponseArray>>();
    public onCreditCardAdd = new Subject<IBaseResponse<string>>();
    public onCreditCardUpdateExpiration = new Subject<IBaseResponse<string>>();
    public onCreditCardSetDefault = new Subject<IBaseResponse<string>>();
    public onCreditCardDelete = new Subject<IBaseResponse<string>>();

    public onCalendarData = new Subject<CalendarEventResponseArray>();

    public onYardAddonOrder = new Subject<YardAddonOrderRequest>();
    public onYardGetPricing = new Subject<IBaseResponse<YardAddonPriceResponse>>();
    public onYardCancel = new Subject<IBaseResponse<string>>();

    public onMemberCredit = new Subject<IBaseResponse<number>>();

    public onTrainingEventByID = new Subject<IBaseResponse<TrainingEvent>>();
    public onRegisterForTrainingEvent = new Subject<IBaseResponse<RegisterForTrainingEventResponse>>();
    public onGetMemberTrainingCalendar = new Subject<IBaseResponse<MemberTrainingCalendarResponse>>();
    public onGetMemberTrainingCertificates = new Subject<IBaseResponse<MemberTrainingCertificateResponseArray>>();
    public onGetTrainingHistory = new Subject<IBaseResponse<TrainingHistoryResponseArray>>();
    public onUpdateTrainingEventSubscriptionStatus = new Subject<IBaseResponse<UpdateTrainingEventSubscriptionStatusResponse>>();
    public onGetTrainingClasses = new Subject<IBaseResponse<TrainingClassArray>>();

    // leave router to protected because of inheritance
    constructor(private http: HttpClient, router: Router) {
        super(http, router);

        // Set baseUrl
        this.baseUrl = this.GetBaseURL();

    }

    // Method that returns the BaseURL of the API based on the current domain
    public GetBaseURL(): string {

        if (this.envName == 'local') {

          //return 'https://localhost:4402/api/';
          return 'https://members-api.structurestudios.com/api/'; // Original API

        } else {

            switch (window.location.hostname) {

                case 'members.structurestudios.com':
                    // return 'https://members-pci-api.structurestudios.com/api/'; // NEW PCI Compliant server/api
                    return 'https://members-api.structurestudios.com/api/'; // Original API

                case 'members-panel-dev.structurestudios.com':
                    this.isDev = true;
                    return 'https://members-api-dev.structurestudios.com/api/';

                case 'member-panel-dev-primo.structurestudios.com':
                    this.isDev = true;
                    return 'https://members-api-dev-primo.structurestudios.com/api/';

                case 'localhost':
                    this.isDev = true;
					// return  'http://localhost:55189/api/';// https://members-api-dev.structurestudios.com/api/''; // DEV API
                    return 'https://members-api.structurestudios.com/api/'; // LIVE API -- BEE CAREFUL!
                    // return 'https://members-pci-api.structurestudios.com/api/'; // NEW PCI Compliant server/api
                    
                case 'members-pci.structurestudios.com':
                    this.isDev = true;
                    return 'https://members-pci-api.structurestudios.com/api/';

                default:
                    this.isDev = true;
                    return 'https://dev-test-api.structurestudios.com/api/';
            }

        }

    }


    // Method that returns the ReportBotURL of the API based on the current domain
    public GetReportBotURL(): string {

        if (this.envName == 'local') {

            return 'https://reports-api.structurestudios.com';

        } else {

            switch (window.location.hostname) {

                case 'members.structurestudios.com':
                    return 'https://reports-api.structurestudios.com';

                case 'members-panel-dev.structurestudios.com':
                    return 'https://reports-api-dev.structurestudios.com';

                case 'localhost':
                    return 'https://reports-api.structurestudios.com';

                default:
                    return 'https://reports-api.structurestudios.com';
            }

        }

    }

    private SetBusy(): void {
        this.IsBusy = true;
        this.onIsBusyChanged.next(true);
    }

    private UnsetBusy(): void {
        this.IsBusy = false;
        this.onIsBusyChanged.next(false);
    }

    private FullURL(url: string): string {
        return this.baseUrl + url;
    }




    // prep

    private getTokenHeader(): HttpHeaders {

        let token = localStorage.getItem('token');
        let headers = new HttpHeaders();

        if (token != undefined) {
            headers = headers.set('Authorization', 'Bearer ' + token);
        }

        return headers;
    }

    private prepGet<T>(referalMethod: string, url: string, key: string = ''): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(url) + key;
        let headers = this.getTokenHeader();

        // request
        return this.Get<T>(url, null, headers)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let apiResponse = new ssApiResponse(url, referalMethod, response);
                    this.onResponse.next(apiResponse);
                    return response;
            }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            )

    }

    public prepPOST<T>(referalMethod: string, request: any, url: string): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(url);
        let headers = this.getTokenHeader();

        // request
        return this.Post<T>(url, request, headers)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let apiResponse = new ssApiResponse(url, referalMethod, response);
                    this.onResponse.next(apiResponse);
                    return response;
    
                }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            )
    }


    public prepPATCH<T>(referalMethod: string, request: any, url: string): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(url);
        let headers = this.getTokenHeader();

        // request
        return this.Patch<T>(url, request, headers)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let apiResponse = new ssApiResponse(url, referalMethod, response);
                    this.onResponse.next(apiResponse);
                    return response;
    
                }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            )

    }

    public prepDelete<T>(referalMethod: string, url: string): Observable<IBaseResponse<T>> {
        this.SetBusy();

        url = this.FullURL(url);
        let headers = this.getTokenHeader();

        // request
        return this.Delete<T>(url, headers)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let apiResponse = new ssApiResponse(url, referalMethod, response);
                    this.onResponse.next(apiResponse);
                    return response;
    
                }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            )

    }


    // Authentication
    public Login(request: LoginRequest): Observable<IBaseResponse<LoginResponse>> {

        let referalMethod = 'Login';

        return this.prepPOST<LoginResponse>(referalMethod, request, ssApiUrls.Authentication_Login)
            .pipe(
                map(response => {

                    if (response.Result) {
                        // only when a true result
                        Object.setPrototypeOf(response.Data, LoginResponse.prototype);
                        //response.Data.FixDates();
                    }
    
                    this.onLoginResponse.next(response);
                    return response;
                })
            );

    }

    public ChangePassword(request: ChangePasswordRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ChangePassword';

        return this.prepPATCH<string>(referalMethod, request, ssApiUrls.Authentication_ChangePassword)
            .pipe(
                map(response => {

                    this.onChangePassword.next(response);
                    return response;
                })
            );

    }

    public SendTwoFactorCode(request: SendTwoFactorCodeOptionRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'SendTwoFactorCode';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Authentication_SendTwoFactorCode)
            .pipe(
                map(response => {

                    this.onSendTwoFactorCode.next(response);
                    return response;
                })
            );

    }

    public SetNewPassword(request: SetNewPasswordRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'SetNewPassword';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Authentication_SetNewPassword)
            .pipe(
                map(response => {

                    this.onSetNewPassword.next(response);
                    return response;
                })
            )
    }

    public ResetPasswordRequest(request: ResetPasswordRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ResetPasswordRequest';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Authentication_ResetPassword)
            .pipe(
                map(response => {

                    this.onResetPasswordRequest.next(response);
                    return response;
                })
            );
    }

    public TwoFactorAuthentication(request: TwoFactorAuthenticationRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'TwoFactorAuthentication';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Authentication_TwoFactorAuthentication)
            .pipe(
                map(response => {

                    this.onTwoFactorAuthentication.next(response);
                    return response;
                })
            );

    }

    public Logout(logoutEverywhere: boolean): Observable<IBaseResponse<string>> {

        let referalMethod = 'Logout';

        return this.prepDelete<string>(referalMethod, ssApiUrls.Authentication_Logout + '/' + logoutEverywhere)
            .pipe(
                map(response => {
                    this.onLogoutResponse.next(response);
                    return response;
                })
            );

    }

    public UnlockLogin(request: IUnlockLoginRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'UnlockLogin';

        return this.prepPATCH<string>(referalMethod, request, ssApiUrls.Authentication_UnlockLogin)
            .pipe(
                map(response => {

                    this.onUnlockLogin.next(response);
                    return response;
                })
            );
    }

    public GetSessionInfo(): Observable<IBaseResponse<LoginResponse>> {

        let referalMethod = 'GetSessionInfo';

        return this.prepGet<LoginResponse>(referalMethod, ssApiUrls.Authentication_SessionInfo)
            .pipe(
                map(response => {

                    if (response.Result) {
                        // only when a true result
                        Object.setPrototypeOf(response.Data, LoginResponse.prototype);
                        //response.Data.FixDates();
                    }
    
                    this.onSessionInfoResponse.next(response);
                    return response;
                })
            );

    }



    // sales
    public SalesUpdateCart(request: UpdateCartRequest): Observable<IBaseResponse<UpdateCartResponse>> {

        let referalMethod = 'SalesUpdateCart';

        return this.prepPOST<UpdateCartResponse>(referalMethod, request, ssApiUrls.Sales_UpdateCart)
            .pipe(
                map(response => {
                    console.log("UpdateCartResponse", response);
                    this.onSalesUpdateCart.next(response);
                    return response;
                })
            );

    }

    public GetUnfinishedOrder(ufoID: string): Observable<IBaseResponse<UnfunishedOrderData>> {

        let referalMethod = 'GetUnfinishedOrder';
        let url = ssApiUrls.Sales_GetUnfinishedOrderData + '/' + ufoID;

        return this.prepGet<UnfunishedOrderData>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onSalesGetUnfinishedOrderData.next(response);
                    return response;
                })
            );

    }


    // Members
    public MemberNew(request: NewMemberRequest): Observable<IBaseResponse<NewMemberResponse>> {

        let referalMethod = 'MemberNew';

        return this.prepPOST<NewMemberResponse>(referalMethod, request, ssApiUrls.Member_New)
            .pipe(
                map(response => {
                    this.onMemberNew.next(response);
                    return response;
                })
            );
    }

    public CheckForExistingMember(request: CheckForExistingMemberRequest): Observable<IBaseResponse<CheckForExistingMemberResponse>> {

        let referalMethod = 'CheckForExistingMember';

        return this.prepPOST<CheckForExistingMemberResponse>(referalMethod, request, ssApiUrls.Member_CheckForExistingMember)
            .pipe(
                map(response => {
                    this.onMemberCheckForExistingMember.next(response);
                    return response;
                })
            );
    }

    public FinishOrder(request: FinishOrderRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'FinishOrder';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Member_FinishOrder)
            .pipe(
                map(response => {
                    this.onFinishOrder.next(response);
                    return response;
                })
            );
    }

    public MemberBasicInfo(): Observable<IBaseResponse<MemberBasicInfoResponse>> {

        let referalMethod = 'MemberBasicInfo';

        return this.prepGet<MemberBasicInfoResponse>(referalMethod, ssApiUrls.Member_BasicInfo)
            .pipe(
                map(response => {

                    this.onMemberBasicInfo.next(response);
                    return response;
                })
            );
    }

    public MemberCredit(): Observable<IBaseResponse<number>> {

        let referalMethod = 'MemberCredit';

        return this.prepGet<number>(referalMethod, ssApiUrls.Member_Credit)
            .pipe(
                map(response => {

                    this.onMemberCredit.next(response);
                    return response;
                })
            );
    }

    public GetMemberAnnouncements(): Observable<IBaseResponse<MemberAnnouncementArray>> {
        let referalMethod = 'MemberAnnouncements';

        return this.prepGet<MemberAnnouncementArray>(referalMethod, ssApiUrls.Member_MemberAnnouncements)
            .pipe(
                map(response => {

                    this.onMemberMemberAnnouncements.next(response);
                    return response;
                })
            );
    }

    public MemberDesignersLicensesBasics(): Observable<IBaseResponse<MemberDesignerLicenseBasicsResponseArray>> {

        let referalMethod = 'MemberDesignersLicensesBasics';

        return this.prepGet<MemberDesignerLicenseBasicsResponseArray>(referalMethod, ssApiUrls.Member_MemberDesignersLicensesBasics)
            .pipe(
                map(response => {

                    this.onMemberDesignersLicensesBasics.next(response);
                    return response;
                })
            );

    }



    public ReferralRedirect(redirectID: number): Observable<IBaseResponse<RedirectResponse>> {

        let referalMethod = 'ReferralRedirect';

        return this.prepGet<RedirectResponse>(referalMethod, ssApiUrls.Referral_Redirect, '/' + redirectID.toString())
            .pipe(
                map(response => {

                    this.onReferralRedirect.next(response);
                    return response;
                })
            );

    }


    public ProductsMyProducts(): Observable<IBaseResponse<DashboardProductsResponse>> {

        let referalMethod = 'ProductsGetAll';

        return this.prepGet<DashboardProductsResponse>(referalMethod, ssApiUrls.Products_MyProducts)
            .pipe(
                map(response => {

                    Object.setPrototypeOf(response.Data, DashboardProductsResponse.prototype);
                    response.Data.InitFromJSON();
    
                    this.onProductsMyProducts.next(response);
                    return response;
                })
            );

    }

    public BillingHistory(): Observable<IBaseResponse<BillingHistoryResponseArray>> {

        let referalMethod = 'BillingHistory';

        return this.prepGet<BillingHistoryResponseArray>(referalMethod, ssApiUrls.Billing_History)
            .pipe(
                map(response => {

                    Object.setPrototypeOf(response.Data, BillingHistoryResponseArray.prototype);
                    response.Data.InitFromJSON();
    
                    this.onBillingHistory.next(response);
                    return response;
                })
            );

    }

    public BillingPayInvoice(request: PayInvoiceRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'BillingPayInvoice';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Billing_PayInvoice)
            .pipe(
                map(response => {

                    this.onBillingPayInvoice.next(response);
                    return response;
                })
            );

    }

    public GISPurchaseHistory(): Observable<IBaseResponse<GISPurchaseItemResponseArray>> {

        let referalMethod = 'GISPurchaseHistory';

        return this.prepGet<GISPurchaseItemResponseArray>(referalMethod, ssApiUrls.GIS_PurchaseHistory)
            .pipe(
                map(response => {

                    Object.setPrototypeOf(response.Data, GISPurchaseItemResponseArray.prototype);
                    response.Data.InitFromJSON();
    
                    this.onGISPurchaseHistory.next(response);
                    return response;
                })
            );

    }

    public GISUsageHistory(): Observable<IBaseResponse<GISUsageHistoryItemResponseArray>> {

        let referalMethod = 'GISUsageHistory';

        return this.prepGet<GISUsageHistoryItemResponseArray>(referalMethod, ssApiUrls.GIS_UsageHistory)
            .pipe(
                map(response => {

                    Object.setPrototypeOf(response.Data, GISUsageHistoryItemResponseArray.prototype);
                    response.Data.InitFromJSON();
    
                    this.onGISUsageHistory.next(response);
                    return response;
                })
            );

    }

    public GISSharedBundle(): Observable<IBaseResponse<GISBundleResponseArray>> {

        let referalMethod = 'GISSharedBundle';

        return this.prepGet<GISBundleResponseArray>(referalMethod, ssApiUrls.GIS_SharedBundle)
            .pipe(
                map(response => {

                    this.onGISSharedBundle.next(response);
                    return response;
                })
            );
    }

    public GISIndividualBundle(): Observable<IBaseResponse<GISBundleResponseArray>> {

        let referalMethod = 'GISIndividualBundle';

        return this.prepGet<GISBundleResponseArray>(referalMethod, ssApiUrls.GIS_IndividualBundle)
            .pipe(
                map(response => {

                    this.onGISIndividualBundle.next(response);
                    return response;
                })
            );
    }

    public CreditCardGetDefault(): Observable<IBaseResponse<CreditCardResponse>> {

        let referalMethod = 'CreditCardGetDefault';

        return this.prepGet<CreditCardResponse>(referalMethod, ssApiUrls.CreditCard_GetDefault)
            .pipe(
                map(response => {

                    Object.setPrototypeOf(response.Data, CreditCardResponse.prototype);
                    //response.Data.FixDates();
    
                    this.onCreditCardGetDefault.next(response);
                    return response;
                })
            );

    }

    public CreditCardGetAll(): Observable<IBaseResponse<CreditCardResponseArray>> {

        let referalMethod = 'CreditCardGetAll';

        return this.prepGet<CreditCardResponseArray>(referalMethod, ssApiUrls.CreditCard_GetAll)
            .pipe(
                map(response => {

                    Object.setPrototypeOf(response.Data, CreditCardResponseArray.prototype);
                    response.Data.InitFromJSON();
    
                    this.onCreditCardGetAll.next(response);
                    return response;
                })
            );

    }

    public CreditCardAdd(request: AddCreditCardRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'CreditCardAdd';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.CreditCard_Add)
            .pipe(
                map(response => {

                    this.onCreditCardAdd.next(response);
                    return response;
                })
            );

    }

    public CreditCardUpdateExpiration(request: UpdateCreditCardExpirationRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'UpdateExpiration';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.CreditCard_UpdateExpiration)
            .pipe(
                map(response => {

                    this.onCreditCardUpdateExpiration.next(response);
                    return response;
                })
            );

    }

    public CreditCardSetDefault(request: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'CreditCardSetDefault';
        let url = ssApiUrls.CreditCard_SetAsDefault + '/' + request;

        return this.prepPATCH<string>(referalMethod, null, url)
            .pipe(
                map(response => {

                    this.onCreditCardSetDefault.next(response);
                    return response;
                })
            );

    }

    public CreditCardDelete(request: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'CreditCardDelete';
        let url = ssApiUrls.CreditCard_Delete + '/' + request;

        return this.prepDelete<string>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onCreditCardDelete.next(response);
                    return response;
                })
            );

    }

    public LicenseReassign(request: CdKeyReassignRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'LicenseReassign';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.License_Reassign)
            .pipe(
                map(response => {

                    this.onLicenseReassign.next(response);
                    return response;
                })
            );

    }

    public GetFirstLicenseKey(): Observable<IBaseResponse<string>> {

        let referalMethod = 'GetFirstLicenseKey';
        let url = ssApiUrls.License_GetFirstLicenseKey;

        return this.prepGet<string>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onGetFirstLicenseKey.next(response);
                    return response;
                })
            );

    }

    public LicenseAssigToLoggedinUser(licenseKey: string): Observable<IBaseResponse<string>> {

        let referalMethod = 'LicenseAssigToLoggedinUser';
        let url = ssApiUrls.License_AssigToLoggedinUser + '/' + licenseKey;

        return this.prepPATCH<string>(referalMethod, null, url)
            .pipe(
                map(response => {

                    this.onLicenseReassign.next(response);
                    return response;
                })
            );

    }

    public SendLicenseKeyInstructionsToDesignerEmail(request: DesignerInstructionsRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'SendLicenseKeyInstructionsToDesignerEmail';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.License_SendLicenseKeyInstructionsToDesignerEmail)
            .pipe(
                map(response => {

                    this.onSendLicenseKeyInstructionsToDesignerEmail.next(response);
                    return response;
                })
            );

    }

    public ProductCancel(request: CancelProductRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ProductCancel';
        let url = ssApiUrls.Products_Cancel;

        return this.prepPATCH<string>(referalMethod, request, url)
            .pipe(
                map(response => {

                    this.onProductsCancel.next(response);
                    return response;
                })
            );

    }

    public ProductsAdd(request: AddProductRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ProductsAdd';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Products_Add)
            .pipe(
                map(response => {

                    this.onProductsAdd.next(response);
                    return response;
                })
            );

    }

    public YardAdd(request: YardAddonOrderRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'YardAdd';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Yard_Add)
            .pipe(
                map(response => {

                    this.onProductsAdd.next(response);
                    return response;
                })
            );

    }

    public YardCancel(request: CancelYardRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'YardCancel';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Yard_Cancel)
            .pipe(
                map(response => {

                    this.onYardCancel.next(response);
                    return response;
                })
            );

    }

    public YardGetPricing(key: string): Observable<IBaseResponse<YardAddonPriceResponse>> {

        let referalMethod = 'YardGetPrices';

        return this.prepGet<YardAddonPriceResponse>(referalMethod, ssApiUrls.Yard_GetPricing, key)
            .pipe(
                map(response => {
                    if (response.Result)
                        //YardAddonPriceResponse.FixDates(response.Data);
    
                    this.onYardGetPricing.next(response);
                    return response;
                })
            );
    }

    public ProductsUpgrade(request: UpgradeProductRequest): Observable<IBaseResponse<UpgradeProductResponse>> {

        let referalMethod = 'ProductsUpgrade';

        return this.prepPOST<UpgradeProductResponse>(referalMethod, request, ssApiUrls.Products_Upgrade)
            .pipe(
                map(response => {

                    this.onProductUpgrade.next(response);
                    return response;
                })
            );

    }

    public ProductsUpgradeSimulation(request: UpgradeProductRequest): Observable<IBaseResponse<UpgradeSimulationResponse>> {

        let referalMethod = 'ProductsUpgradeSimulation';

        return this.prepPOST<UpgradeSimulationResponse>(referalMethod, request, ssApiUrls.Products_UpgradeSimulation)
            .pipe(
                map(response => {

                    if (response.Result)
                        //UpgradeSimulationResponse.FixDates(response.Data);
    
                    this.onProductUpgradeSimulation.next(response);
                    return response;
                })
            );

    }

    public ProductsReactivateSimulation(licenseKey: string): Observable<IBaseResponse<ReactivateSimulationResponse>> {

        let referalMethod = 'ProductsReactivateSimulation';

        return this.prepGet<ReactivateSimulationResponse>(referalMethod, ssApiUrls.Products_ReactivateSimulation, licenseKey)
            .pipe(
                map(response => {

                    if (response.Result)
                        //ReactivateSimulationResponse.FixDates(response.Data);
    
                    this.onProductReactivateSimulationn.next(response);
                    return response;
                })
            );

    }


    public CheckHoldEligibility(licenseKey: string): Observable<IBaseResponse<CheckHoldEligibilityResponse>> {

        let referalMethod = 'CheckHoldEligibility';

        return this.prepGet<CheckHoldEligibilityResponse>(referalMethod, ssApiUrls.Products_CheckHoldEligibility, licenseKey)
            .pipe(
                map(response => {

                    this.onCheckHoldEligibility.next(response);
                    return response;
                })
            );

    }

    public HoldLicense(request: HoldRequest): Observable<IBaseResponse<any>> {

        let referalMethod = 'HoldLicense';

        return this.prepPOST<boolean>(referalMethod, request, ssApiUrls.Products_Hold)
            .pipe(
                map(response => {

                    this.onHoldLicense.next(response);
                    return response;
                })
            );

    }


    public ExtendHoldLicense(request: HoldRequest): Observable<IBaseResponse<any>> {

        let referalMethod = 'ExtendHold';

        return this.prepPOST<boolean>(referalMethod, request, ssApiUrls.Products_ExtendHold)
            .pipe(
                map(response => {

                    this.onExtendHoldLicense.next(response);
                    return response;
                })
            );

    }
   
    public ResumeLicenseSimulation(request: ResumeLicenseSimulationRequest): Observable<IBaseResponse<ResumeLicenseSimulationResponse>> {

        let referalMethod = 'ResumeLicenseSimulation';

        return this.prepPOST<ResumeLicenseSimulationResponse>(referalMethod, request, ssApiUrls.Products_ResumeLicenseSimulation)
            .pipe(
                map(response => {

                    this.onResumeLicenseSimulation.next(response);
                    return response;
                })
            );

    } 
   
    public ResumeLicense(request: ResumeLicenseRequest): Observable<IBaseResponse<boolean>> {

        let referalMethod = 'ResumeLicense';

        return this.prepPOST<boolean>(referalMethod, request, ssApiUrls.Products_ResumeLicense)
            .pipe(
                map(response => {

                    this.onResumeLicense.next(response);
                    return response;
                })
            );

    } 

    public ProductsReactivateSimulationv2(request: ReactivateSimulationRequestv2): Observable<IBaseResponse<ReactivateSimulationResponsev2>> {

        let referalMethod = 'ReactivateSimulationv2';

        return this.prepPOST<ReactivateSimulationResponsev2>(referalMethod, request, ssApiUrls.Products_ReactivateSimulationv2)
            .pipe(
                map(response => {

                    if (response.Result)
                        //ReactivateSimulationResponse.FixDates(response.Data);
    
                    this.onProductReactivateSimulationnv2.next(response);
                    return response;
                })
            );

    }

    public ProductsReactivate(request: ReactivateRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ProductsReactivate';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Products_Reactivate)
            .pipe(
                map(response => {

                    this.onProductReactivate.next(response);
                    return response;
                })
            );

    }

    public ProductsReactivatev2(request: ReactivateRequestv2): Observable<IBaseResponse<string>> {

        let referalMethod = 'ProductsReactivatev2';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Products_Reactivatev2)
            .pipe(
                map(response => {

                    this.onProductReactivatev2.next(response);
                    return response;
                })
            );

    }

    public ProductsPublicOrderProducts(): Observable<IBaseResponse<PublicOrderProductsResponseArray>> {

        let referalMethod = 'ProductsPublicOrderProducts';
        let url = ssApiUrls.Products_PublicOrderProducts;

        return this.prepGet<PublicOrderProductsResponseArray>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onProductsPublicOrderProducts.next(response);
                    return response;
                })
            );

    }

    public ProductsOrderProducts(): Observable<IBaseResponse<PublicOrderProductsResponseArray>> {

        let referalMethod = 'ProductsOrderProducts';
        let url = ssApiUrls.Products_OrderProducts;

        return this.prepGet<PublicOrderProductsResponseArray>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onProductsOrderProducts.next(response);
                    return response;
                })
            );
    }

    public ProductsPublicAndSpecialOrderProducts(): Observable<IBaseResponse<PublicOrderProductsResponseArray>> {

        let referalMethod = 'ProductsPublicAndSpecialOrderProducts';
        let url = ssApiUrls.Products_PublicAndSpecialOrderProducts;

        return this.prepGet<PublicOrderProductsResponseArray>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onProductsPublicOrderProducts.next(response);
                    return response;
                })
            );

    }

    public ProductsUpgradableProducts(licenseKey: string): Observable<IBaseResponse<UpgradableProductsResponseArray>> {

        let referalMethod = 'ProductsUpgradableProducts';
        let url = ssApiUrls.Products_UpgradableProducts + '/' + licenseKey;

        return this.prepGet<UpgradableProductsResponseArray>(referalMethod, url)
            .pipe(
                map(response => {

                    this.onProductsUpgradableProducts.next(response);
                    return response;
                })
            );

    }

    public CalendarData(start: string, end: string): Observable<CalendarEventResponseArray> {

        this.SetBusy();

        let url = 'https://api.structurestudios.com/ISWebService/Member.svc/Json/GetCalenderData';
        let headers = new HttpHeaders();
        headers.set('Content-Type', 'application/json');

        // 'MM/DD/YYYY'
        let data = JSON.stringify({
            start: start,
            end: end
        });

        // request
        return this.PostRaw(url, data, headers, false)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let data = response.json() as any;
                    data = data.d as CalendarEventResponseArray;
    
                    this.onCalendarData.next(data);
                    return data;
    
                }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            );

    }

    public TrainingEventData(ScheduleID: string): Observable<TrainingEventDetailsResponse> {

        this.SetBusy();

        // let url = "https://api.structurestudios.com/ISWebService/Member.svc/Json/GetCalenderInfo";
        let url = 'https://api.structurestudios.com/ISWebService/Member.svc/Json/GetCalenderInfo';
        let headers = new HttpHeaders();
        headers.set('Content-Type', 'application/json');

        // 'MM/DD/YYYY'
        let data = JSON.stringify({
            ScheduleID
        });

        // request
        return this.PostRaw(url, data, headers, false)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let data = response.json() as any;
                    data = data.d as TrainingEventDetailsResponse;
    
                    this.onCalendarData.next(data);
                    return data;
    
                }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            );

    }

    public TrainingEventJoin(request: TrainingJoinEventRequest): Observable<TrainingJoinEventResponse> {

        this.SetBusy();

        let url = 'https://api.structurestudios.com/ISWebService/Member.svc/Json/JoinEvent';
        let headers = new HttpHeaders();
        headers.set('Content-Type', 'application/json');

        // 'MM/DD/YYYY'
        let data = JSON.stringify({
            Token: request.Token,
            ScheduleID: request.ScheduleID,
            Email: request.Email,
            CDKEY: request.CDKEY,
            AdditionalEmail: request.AdditionalEmail,
            AdditionalPhone: request.AdditionalPhone,
        });

        // request
        return this.PostRaw(url, data, headers, false)
            .pipe(
                map(response => {
                    this.UnsetBusy();
    
                    let data = response.json() as any;
                    data = data.d as TrainingJoinEventResponse;
    
                    this.onCalendarData.next(data);
                    return data;
    
                }),
                catchError((error: HttpError) => {
                    this.UnsetBusy();
                    return throwError(error);
                })
            );

    }


    public GISOrder(request: OrderGISRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'GISOrder';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.GIS_Order)
            .pipe(
                map(response => {

                    this.onGISOrder.next(response);
                    return response;
                })
            );

    }

    // training (ssdb2)

    public RegisterForTrainingEvent(request: RegisterForTrainingEventRequest): Observable<IBaseResponse<RegisterForTrainingEventResponse>> {

        let referalMethod = 'RegisterForTrainingEvent';

        return this.prepPOST<RegisterForTrainingEventResponse>(referalMethod, request, ssApiUrls.Training_RegisterForTrainingEvent)
            .pipe(
                map(response => {
                    this.onRegisterForTrainingEvent.next(response);
                    return response;
                })
            );

    }

    public GetMemberTrainingCalendar(request: TrainingCalendarRequest): Observable<IBaseResponse<MemberTrainingCalendarResponse>> {

        let referalMethod = 'GetMemberTrainingCalendar';

        return this.prepPOST<MemberTrainingCalendarResponse>(referalMethod, request, ssApiUrls.Training_GetMemberTrainingCalendar)
            .pipe(
                map(response => {
                    this.onGetMemberTrainingCalendar.next(response);
                    return response;
                })
            );
    }

    public GetMemberTrainingCertificates(request: MemberTrainingCertificatesRequest): Observable<IBaseResponse<MemberTrainingCertificateResponseArray>> {

        let referalMethod = 'GetMemberTrainingCertificates';

        return this.prepPOST<MemberTrainingCertificateResponseArray>(referalMethod, request, ssApiUrls.Training_GetMemberTrainingCertificates)
            .pipe(
                map(response => {
                    this.onGetMemberTrainingCertificates.next(response);
                    return response;
                })
            );
    }

    public GetTrainingClasses(request: GetTrainingClassesRequest): Observable<IBaseResponse<TrainingClassArray>> {

        let referalMethod = 'GetTrainingClasses';

        return this.prepPOST<TrainingClassArray>(referalMethod, request, ssApiUrls.Training_GetTrainingClasses)
            .pipe(
                map(response => {
                    this.onGetTrainingClasses.next(response);
                    return response;
                })
            );
    }

    public GetTrainingHistory(): Observable<IBaseResponse<TrainingHistoryResponseArray>> {

        let referalMethod = 'GetTrainingHistory';

        return this.prepGet<TrainingHistoryResponseArray>(referalMethod, ssApiUrls.Training_GetTrainingHistory)
            .pipe(
                map(response => {
                    this.onGetTrainingHistory.next(response);
                    return response;
                })
            );

    }

    public UpdateTrainingEventSubscriptionStatus(request: UpdateTrainingEventSubscriptionStatusRequest): Observable<IBaseResponse<UpdateTrainingEventSubscriptionStatusResponse>> {

        let referalMethod = 'UpdateTrainingEventSubscriptionStatus';

        return this.prepPOST<UpdateTrainingEventSubscriptionStatusResponse>(referalMethod, request, ssApiUrls.Training_UpdateTrainingEventSubscriptionStatus)
            .pipe(
                map(response => {
                    this.onUpdateTrainingEventSubscriptionStatus.next(response);
                    return response;
                })
            );
    }

    public UpdateMemberProfile(request: UpdateMemberProfileRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'CheckForExistingMember';

        return this.prepPOST<string>(referalMethod, request, ssApiUrls.Member_UpdateProfile)
            .pipe(
                map(response => {
                    this.onMemberUpdateProfile.next(response);
                    return response;
                })
            );
    }

    public MemberProfile(): Observable<IBaseResponse<MemberProfile>> {

        let referalMethod = 'MemberProfile';

        return this.prepGet<MemberProfile>(referalMethod, ssApiUrls.Member_Profile)
            .pipe(
                map(response => {

                    this.onMemberProfile.next(response);
                    return response;
                })
            );
    } 

}
